module.exports = __webpack_public_path__ + "static/LotB-c33bdc847d77d2bab2a9d219a3e12b3f.png";